import BoxComponent, { BoxProps } from '@material-ui/core/Box';
import CheckboxComponent, { CheckboxProps } from '@material-ui/core/Checkbox';
import TypographyComponent, {
  TypographyProps,
} from '@material-ui/core/Typography';
import { ToggleButtonGroup } from '@material-ui/lab';
import palette from 'assets/palette';
import styled from 'styled-components';

export const Typography = styled(TypographyComponent)<TypographyProps>``;

export const TopBar = styled(BoxComponent)<BoxProps>`
  &.MuiBox-root {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: 0.5rem;
  }
`;

export const DatePickerWrapper = styled(BoxComponent)<BoxProps>`
  &.MuiBox-root {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const Checkbox = styled(CheckboxComponent)<CheckboxProps>`
  &.MuiCheckbox-root {
    color: rgb(0 0 0);
  }
  &.MuiCheckbox-colorSecondary.Mui-checked {
    color: ${palette.ACTION};
  }
  &.MuiIconButton-colorSecondary:hover {
    background-color: ${palette.ACTION_LIGHTER};
  }
`;

export const CheckboxBox = styled(BoxComponent)<BoxProps>`
  &.MuiBox-root {
    margin-left: 4vw;
    @media (max-width: 1280px) {
      margin-top: 1vh;
      margin-bottom: 1vh;
    }
  }
`;

export const FilterBar = styled(BoxComponent)<BoxProps>`
  &.MuiBox-root {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 16px;
  }
`;

export const MonthPicker = styled.div`
  flex: 0 0 230px;
  & .MuiFormControl-root {
    margin-top: 0;
  }
`;

export const FilterNote = styled(TypographyComponent)<TypographyProps>`
  &.MuiTypography-root {
    font-size: 0.875rem;
    color: ${palette.ACCENT_DARKER};
  }
`;

export const SegmentedControl = styled(ToggleButtonGroup)`
  &.MuiToggleButtonGroup-root {
    flex-wrap: wrap;
  }
  & .MuiToggleButton-root {
    height: 40px;
    text-transform: none;
    color: ${palette.ACCENT_DARKEST};
  }
  & .MuiToggleButton-root.Mui-selected {
    background-color: ${palette.ACTION_LIGHTER};
    color: rgb(0 0 0);
  }
  & .MuiToggleButton-root.Mui-selected:hover {
    background-color: ${palette.ACTION};
  }
`;

export const SegmentedCount = styled.span`
  margin-left: 6px;
  padding: 0 6px;
  min-width: 20px;
  border-radius: 10px;
  font-size: 0.75rem;
  line-height: 20px;
  background-color: ${palette.ACCENT_LIGHTEST};
  color: ${palette.ACCENT_DARKEST};
`;

export const FilterActions = styled(BoxComponent)<BoxProps>`
  &.MuiBox-root {
    margin-left: auto;
  }
  & .MuiButton-root {
    height: 40px;
  }
`;
